import { Injectable } from '@angular/core';
import { CustomCategoryHierarchy } from '@catalog/const';
import { CatalogActions, OccCategoryDetailsService } from '@catalog/data-access';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { ProductActions } from '@spartacus/core';
import { Observable, of } from 'rxjs';
import { catchError, filter, map, switchMap } from 'rxjs/operators';

@Injectable()
export class CategoryDetailsEffects {
  searchProductsResetDetails$: Observable<CatalogActions.ResetCategoryDetails> = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductActions.SEARCH_PRODUCTS),
      filter(({ auxiliary }: ProductActions.SearchProducts) => !auxiliary),
      map(() => new CatalogActions.ResetCategoryDetails()),
    ),
  );

  searchProductsLoadDetails: Observable<CatalogActions.LoadCategoryDetails> = createEffect(() =>
    this.actions$.pipe(
      ofType(ProductActions.SEARCH_PRODUCTS),
      map((action: ProductActions.SearchProducts) => {
        const facets = (action.payload.searchConfig as any)?.facets;

        return typeof facets === 'string' ? facets.match('allCategories:([^,]+)')?.[1] : undefined;
      }),
      filter(Boolean),
      map((categoryId: string) => new CatalogActions.LoadCategoryDetails(categoryId)),
    ),
  );

  loadCategoryDetails$: Observable<CatalogActions.LoadCategoryDetailsSuccess | CatalogActions.LoadCategoryDetailsFail> =
    createEffect(() =>
      this.actions$.pipe(
        ofType(CatalogActions.CATEGORY_DETAILS_LOAD),
        map((action: CatalogActions.LoadCategoryDetails) => action.payload),
        switchMap((categoryId) =>
          categoryId
            ? this.occCategoryDetailsService.loadDetails(categoryId).pipe(
                map((data: CustomCategoryHierarchy) => new CatalogActions.LoadCategoryDetailsSuccess(data)),
                catchError((e: unknown) => of(new CatalogActions.LoadCategoryDetailsFail(e))),
              )
            : of(new CatalogActions.LoadCategoryDetailsFail({})),
        ),
      ),
    );

  constructor(
    private actions$: Actions,
    private occCategoryDetailsService: OccCategoryDetailsService,
  ) {}
}
